import SignInCard from "../components/pageParts/auth/SignInCard";

export default function SignIn() {
    return (
        <SignInCard />
    );
}
